import api from './api';

export const universalService = {
  deleteItem: async (path, id, headers) => {
    try {
      const response = await api.delete(`/${path}/${id}/delete/`, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao deletar item:', error);
      throw error;
    }
  },

  getCommercialTable: async (filters = {}) => {   // ✅ trocar '=' por ':'
    try {
      const response = await api.get('/proposals/list/', { params: filters });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

 getEngineeringTable: async () => {
    try {
      const response = await api.get('/engineering/list');
      return response.data; // retorna diretamente os dados
    } catch (error) {
      throw error;
    }
  },

   getFullNameById: (ownerId, owners) => {
    if (owners) {
      const ownerObj = owners.find(user => user.id === ownerId);
      if (ownerObj) {
        return ownerObj.full_name;
      }
    }
    return 'unknown';
  },

};
